// extracted by mini-css-extract-plugin
export var container = "_2o-0";
export var icon = "_2o-1";